// import focus from 'ally.js/esm/element/focus';
import {offset} from '../base/utils';

class FocusHandler {
    constructor() {

    }

    static focus($target) {
        if (!$target)
            return;

        if ($target.classList.contains('tabs-body')) {
            FocusHandler.openTab($target);
        } else {
            FocusHandler.scrollToAnchor($target);
        }
    }

    static scrollToAnchor($target) {
        let $modal = $target.closest('.modal-inner'),
            $container = $modal || window,
            position = offset($target, $container);

        if ($modal) {
            let $wrap = $modal.querySelector('.modal-popup'),
                offset = $wrap ? parseFloat(window.getComputedStyle($wrap).getPropertyValue('padding-top')) : 0;

            if (position.top - 30 <= offset) {
                position.top = 0;
            } else {
                position.top -= 20 + 84; // odstep miedzy kotwica a tytulem + wysokosc belki
            }
        }

        $container.scroll({top: position.top, left: 0, behavior: 'smooth'});
        // $target.setAttribute('tabindex', -1);
        // focus($target);
    }

    static openTab($target) {
        let $tabsList = $target.closest('.tabs-wrap'),
            $trigger = $tabsList.querySelector(`[href="#${$target.id}"]`);

        $trigger.click();
    }
}

export default FocusHandler;
